import { render, staticRenderFns } from "./SoftwareUninstall.vue?vue&type=template&id=25e281f8&scoped=true"
import script from "./SoftwareUninstall.vue?vue&type=script&lang=js"
export * from "./SoftwareUninstall.vue?vue&type=script&lang=js"
import style0 from "./SoftwareUninstall.vue?vue&type=style&index=0&id=25e281f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e281f8",
  null
  
)

export default component.exports